import { AutogenModelEdiStandardCodeLookup, AutogenRowEdiStandardCodeLookup } from "./autogen/AutogenModelEdiStandardCodeLookup";

export class ModelEdiStandardCodeLookup extends AutogenModelEdiStandardCodeLookup<RowEdiStandardCodeLookup> {
	constructor() {
		super(RowEdiStandardCodeLookup);
	}
}

export class RowEdiStandardCodeLookup extends AutogenRowEdiStandardCodeLookup {
}